// extracted by mini-css-extract-plugin
export var lg = "_42-4";
export var md = "_42-3";
export var sm = "_42-2";
export var xs = "_42-1";
export var xxs = "_42-0";